import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

class OverlayTooltip extends React.Component {
  render() {
    let tooltip = <Tooltip id={this.props.id}>{this.props.tooltip}</Tooltip>;

    return (
      <OverlayTrigger
        overlay={tooltip} placement="top"
        delayShow={300} delayHide={150}
      >
        <span className="dotted_u">{this.props.children}</span>
      </OverlayTrigger>
    );
  }
};

 export default OverlayTooltip;


// WEBPACK FOOTER //
// ./src/OverlayTooltip.js